'use client';

import { createClient } from '@/lib/supabase/client';

interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  category: string;
  image: string;
  alt: string;
  readTime: string;
  content?: string;
}

function isSchemaError(error: any): boolean {
  if (!error) return false;

  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') {
      return true;
    }
  }

  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
      /syntax error/i,
    ];
    return schemaErrorPatterns.some((pattern) => pattern.test(error.message));
  }

  return false;
}

export const blogService = {
  async getAll(): Promise<BlogPost[]> {
    const supabase = createClient();

    try {
      const { data, error } = await supabase
        .from('blog_posts')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) {
        if (error.code === 'PGRST116') {
          return [];
        }
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Data error:', error.message);
          return [];
        }
      }

      return data?.map((row) => ({
        id: row.id,
        title: row.title,
        excerpt: row.excerpt,
        author: row.author,
        date: row.date,
        category: row.category,
        image: row.image,
        alt: row.alt,
        readTime: row.read_time,
        content: row.content,
      })) || [];
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};
